import type { OrcamentoResponse } from '@triade/contracts';
import { useVersoesOrcamento } from '@/api/orcamentos';
import { ErroFormacao } from '@/components/formacao/avisos-formacao';
import { CompararVersoes } from './comparar-versoes';
import { LinhaDoTempo } from './linha-tempo';
import { ListaVersoes } from './lista-versoes';

export interface AbaVersoesProps {
  /** Detalhe do orcamento (cabecalho, meta/minimo em `exibicao` e a linha do tempo em `eventos`). */
  detalhe: OrcamentoResponse;
  numeroAtual: number;
  onVer: (n: number) => void;
}

/** Aba Versoes do detalhe: lista, comparar duas versoes e linha do tempo. Cada bloco tem carregando, vazio e erro. */
export function AbaVersoes({ detalhe, numeroAtual, onVer }: AbaVersoesProps) {
  const versoes = useVersoesOrcamento(detalhe.id);
  const meta = detalhe.exibicao.metaLucro;
  const minimo = detalhe.exibicao.minimoLucro ?? '0';
  const lista = versoes.data ?? [];

  return (
    <div className="flex flex-col gap-5">
      <section aria-label="Lista de versões" className="rounded-2xl border border-border bg-card px-5 py-4">
        <h2 className="mb-3 text-title font-semibold">Versões</h2>
        {versoes.isPending && <p role="status" className="py-6 text-center text-small text-ink-muted">Carregando versões…</p>}
        {versoes.isError && <ErroFormacao erro={versoes.error} onTentar={() => void versoes.refetch()} />}
        {versoes.data && lista.length === 0 && <p className="py-6 text-center text-small text-ink-muted">Este orçamento ainda não tem versões.</p>}
        {versoes.data && lista.length > 0 && <ListaVersoes versoes={lista} numeroAtual={numeroAtual} meta={meta} minimo={minimo} onVer={onVer} />}
      </section>

      <section aria-label="Comparar versões" className="rounded-2xl border border-border bg-card px-5 py-4">
        <h2 className="mb-3 text-title font-semibold">Comparar</h2>
        {versoes.data && lista.length < 2 && <p className="text-small text-ink-muted">Para comparar, o orçamento precisa de pelo menos duas versões.</p>}
        {versoes.data && lista.length >= 2 && <CompararVersoes orcamentoId={detalhe.id} versoes={lista} meta={meta} minimo={minimo} />}
        {versoes.isPending && <p role="status" className="text-small text-ink-muted">Carregando versões para comparar…</p>}
      </section>

      <section aria-label="Linha do tempo do orçamento" className="rounded-2xl border border-border bg-card px-5 py-4">
        <h2 className="mb-3 text-title font-semibold">Linha do tempo</h2>
        <LinhaDoTempo eventos={detalhe.eventos} />
      </section>
    </div>
  );
}
